module.exports = __webpack_public_path__ + "media/icons/smartsearch/materials/combi-28ba8f84e3033a736e1629579cfaedb0.png";